<script>
export default {
  name: 'CitedInfos',
  data() {
    return {
      citedId: 0,
      cited: {
        cited_name: '',
        cited_create_date: '',
        cited_logo: '',
        cited_address: '',
        cited_cellular: '',
        cited_city: '',
      },
    }
  },
  mounted() {
    this.loadCited()
  },
  methods: {
    loadCited() {
      this.$axios.post(this.$endpoint.LoadCited).then(rp => {
        this.cited = rp.data
        this.citedId = rp.data.id
      })
    },
    modifiedCited() {
      this.$axios.post(this.$endpoint.ModifiedCited(this.citedId), this.cited).then(rp => {
        this.cited = rp.data
      })
    },
  },

}
</script>

<template>
  <div>
    <v-card-text class="d-flex">
      <v-avatar
          rounded
          size="120"
          class="me-6"
      >
        <v-img src="@/assets/images/logo/logo_1.jpeg"></v-img>
      </v-avatar>

      <!-- upload photo -->
      <div>
        <v-btn
            color="primary"
            class="me-3 mt-5"
        >
          <v-icon class="d-sm-none">
            mdiCloudUploadOutline
          </v-icon>
          <span class="d-none d-sm-block">Changer</span>
        </v-btn>

        <input
            ref="refInputEl"
            type="file"
            accept=".jpeg,.png,.jpg,GIF"
            :hidden="true"
        />
        <p class="text-sm mt-5">
          format autorisés: JPG, GIF or PNG.
        </p>
      </div>
    </v-card-text>
    <v-row>
      <v-col
          cols="12"
          md="12"
      >
            <span
                class="text-lg-h5  mb-4"
                style="justify-content: center; display: flex;"
            >
              Informations de la cité
            </span>
      </v-col>
    </v-row>
    <v-form
        class="multi-col-validation"
        style="margin-top:1rem;margin-left: 1rem; margin-bottom: 1.5rem;"
    >
      <v-row>
        <v-col
            cols="12"
            md="6"
        >
          <v-text-field
              v-model="cited.cited_name"
              dense
              hide-details
              label="Nom"
              outlined
              placeholder="Non de la citée"
          ></v-text-field>
        </v-col>

        <v-col
            cols="12"
            md="6"
        >
          <v-text-field
              v-model="cited.cited_create_date"
              dense
              type="date"
              hide-details
              label="Date de création"
              outlined
              placeholder=""
          ></v-text-field>
        </v-col>

        <v-col
            cols="12"
            md="6"
        >
          <v-text-field
              v-model="cited.cited_address"
              dense
              hide-details
              label="Address"
              outlined
              placeholder="Code postale"
          ></v-text-field>
        </v-col>
        <v-col
            cols="12"
            md="6"
        >
          <v-text-field
              v-model="cited.cited_cellular"
              dense
              hide-details
              label="Contact"
              outlined
              placeholder="Numéro de telephone"
          ></v-text-field>
        </v-col>
        <v-col
            cols="12"
            md="6"
        >
          <v-text-field
              v-model="cited.cited_city"
              dense
              hide-details
              label="Ville"
              outlined
              placeholder="Ville"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-btn
              color="primary"
              @click="modifiedCited"
          >
            Modifier
          </v-btn>
          <v-btn
              class="mx-2"
              outlined
              type="reset"
          >
            Annuler
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<style scoped>

</style>